import { ThemeBuilderSchemas } from './types';
import { THEME_SCHEMAS_REGISTRY } from '@iws/theme-schema/themes/schemas-registry'

// Every registered theme (packages/theme-schema/src/themes/schemas-registry.ts): a new theme needs no entry here.
const THEME_SCHEMAS = THEME_SCHEMAS_REGISTRY as unknown as Record<string, ThemeBuilderSchemas>

export const KNOWN_THEME_IDS = new Set(Object.keys(THEME_SCHEMAS))

export const getThemeBuilderSchemas = (themeId: string | undefined): ThemeBuilderSchemas => {
  return THEME_SCHEMAS[themeId]
}
